export const TEST_CASE_MESSAGE_COMPONENTS = (comp) => ({
  SHOULD_RENDER_SUCCESSFULLY: `Component ${comp} in Ebook Feature should render successfully`,
});

export const MOCK_EBOOK_RESPONSE = {
  message: '[MOCK] 3 E-books Found',
  data: [
    {
      name: 'Stockbit Pro Guide',
      alias: 'Stockbit_Pro_Guide',
      image: 'guidepro.jpg',
    },
    {
      name: 'Chartbit Guide',
      alias: 'Chartbit_Guide',
      image: 'valuation.jpg',
    },
    {
      name: 'Stock Valuation Guide',
      alias: 'Stock_Valuation_Guide',
      image: 'valuation.jpg',
    },
  ],
};

export const MOCK_EBOOK_SINGLE_RESPONSE = {
  message: '[MOCK] Retrieved E-Book Stockbit Pro Guide details',
  data: {
    id: 2,
    name: 'Stockbit Pro Guide',
    alias: 'Stockbit_Pro_Guide',
    description: '<p>Panduan online untuk pengunaan Stockbit Pro.</p>',
    image: 'guidepro.jpg',
    file: 'Stockbit+Pro+Guide.pdf',
    downloaded: 2033,
  },
};

export const DATA_CY_EBOOK_HEADER_EXPAND_BUTTON = 'ebook-header-expand-button';
export const DATA_CY_EBOOK_MAIN_COMPONENT = 'ebook-main-component';
export const DATA_CY_EBOOK_PANE_COMPONENT = 'ebook-pane-component';
export const DATA_CY_EBOOK_PAGE_COMPONENT = 'ebook-page-component';
export const DATA_CY_EBOOK_CARD_COMPONENT = 'ebook-card-component';
export const DATA_CY_EBOOK_PANE_COMPONENT_BTN_DOWNLOAD = 'ebook-pane-component-btn-download';
